export default __webpack_public_path__ + "static/media/bellIcon.f6413eec.svg";